import { PROGRAM_TYPE } from '@utils/enum'

const CustomStepper = ({ cameFrom }: { cameFrom: string }) => {
  return (
    <div className="flex flex-col items-center mt-0 xxs:mt-1">
      {/* Dot 1 */}
      <div className="w-[10px] h-[10px] rounded-full bg-[#9387FF]" />

      {/* Line */}
      <div className="w-[2px] h-[38px] xxs:h-6 bg-[#D9DCE1]" />

      {/* Dot 2 */}
      <div className="w-[10px] h-[10px] rounded-full bg-[#9387FF]" />

      {/* Line */}
      {cameFrom !== PROGRAM_TYPE.CSC_PROGRAM && (
        <>
          <div className="w-[2px] h-[38px] xxs:h-6 bg-[#D9DCE1]" />

          {/* Dot 3 */}
          <div className="w-[10px] h-[10px] rounded-full bg-[#9387FF]" />
        </>
      )}
    </div>
  )
}

export default CustomStepper
